import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { asyncConnect, withSagas } from 'react-async-client';
import { Spin } from 'antd';

import { authLogoutSaga } from 'sagas/links';
import Modals from 'components/Modals';
import ErrorHTML from 'components/common/form/ErrorHTML';
import { getScenarioAuth } from 'actions/asyncActions';
import Scenario from 'components/views/education/scenario/Scenario';
import TopMenu from 'components/layout/user/TopMenu';

const stateToProps = (state, { location }) => ({
    authKey: qs.parse(location.search, { ignoreQueryPrefix: true }).authKey
});

@asyncConnect({
    getScenarioAuth: getScenarioAuth
        .withPayload(({ authKey }) => ({ authKey }))
        .withOptions({ dispatchOnMount: true })
}, stateToProps)
@withSagas([
    authLogoutSaga
])
export default class ScenarioLinkView extends Component {
    static propTypes = {
        getScenarioAuth: PropTypes.object.isRequired
    }

    render() {
        const { meta, data } = this.props.getScenarioAuth;

        return (
            <Spin className='scenario-spin' spinning={meta.pending}>
                <div className="scenario-layout">
                    <TopMenu noUser={true} />
                    <ErrorHTML meta={meta} />
                    { meta.success && <Scenario params={data} />}
                    <Modals />
                </div>
            </Spin>
        );
    }
}
